import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { DICT } from '../utils/dictionary';

const MESES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

const FILTROS_VAZIOS = {
  status: '', views: '', titulo: '', colaborador: '', cargo: '',
  tipo: '', ordem: 'recentes', mes: '', ano: ''
};

const FilterSection = ({ filters = {}, setFilters }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const limpar = () => setFilters(FILTROS_VAZIOS);

  const temFiltroAtivo = Object.entries(filters).some(
    ([k, v]) => k !== 'ordem' && v !== '' && v !== undefined
  );

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <span className="small fw-bold text-uppercase text-secondary" style={{ letterSpacing: '0.5px' }}>
          <i className="bi bi-funnel me-1"></i> Filtros
        </span>
        {temFiltroAtivo && (
          <Button variant="link" size="sm" className="p-0 text-muted text-decoration-none" onClick={limpar}>
            <i className="bi bi-x-circle me-1"></i>Limpar filtros
          </Button>
        )}
      </div>

      <Row className="g-3">
        {/* Busca textual */}
        <Col md={4} sm={12}>
          <Form.Label className="small text-muted mb-1">Título</Form.Label>
          <Form.Control
            size="sm"
            type="text"
            name="titulo"
            placeholder={`Buscar por título...`}
            value={filters.titulo || ''}
            onChange={handleChange}
          />
        </Col>

        <Col md={4} sm={6}>
          <Form.Label className="small text-muted mb-1">Colaborador</Form.Label>
          <Form.Control
            size="sm"
            type="text"
            name="colaborador"
            placeholder="Nome do colaborador..."
            value={filters.colaborador || ''}
            onChange={handleChange}
          />
        </Col>

        <Col md={4} sm={6}>
          <Form.Label className="small text-muted mb-1">Cargo</Form.Label>
          <Form.Control
            size="sm"
            type="text"
            name="cargo"
            placeholder="Cargo do colaborador..."
            value={filters.cargo || ''}
            onChange={handleChange}
          />
        </Col>

        {/* Seleções */}
        <Col md={2} sm={6}>
          <Form.Label className="small text-muted mb-1">Status</Form.Label>
          <Form.Select name="status" value={filters.status || ''} onChange={handleChange} size="sm">
            <option value="">Todos</option>
            <option value="pendente">Pendente</option>
            <option value="pago">Pago</option>
          </Form.Select>
        </Col>

        <Col md={2} sm={6}>
          <Form.Label className="small text-muted mb-1">{DICT.FORMAT_LABEL}</Form.Label>
          <Form.Select name="tipo" value={filters.tipo || ''} onChange={handleChange} size="sm">
            <option value="">Todos</option>
            {DICT.TIPOS_CONTEUDO.map(t => (
              <option key={t} value={t.toLowerCase()}>{t}</option>
            ))}
          </Form.Select>
        </Col>

        <Col md={2} sm={6}>
          <Form.Label className="small text-muted mb-1">Mês</Form.Label>
          <Form.Select name="mes" value={filters.mes || ''} onChange={handleChange} size="sm">
            <option value="">Todos</option>
            {MESES.map((nome, i) => {
              const val = String(i + 1).padStart(2, '0');
              return <option key={val} value={val}>{nome}</option>;
            })}
          </Form.Select>
        </Col>

        <Col md={2} sm={6}>
          <Form.Label className="small text-muted mb-1">Ano</Form.Label>
          <Form.Control
            size="sm"
            type="number"
            name="ano"
            placeholder="Ex: 2025"
            value={filters.ano || ''}
            onChange={handleChange}
          />
        </Col>

        <Col md={2} sm={6}>
          <Form.Label className="small text-muted mb-1">Mín. {DICT.METRIC_PLUR}</Form.Label>
          <Form.Control
            size="sm"
            type="number"
            name="views"
            placeholder="Ex: 100000"
            value={filters.views || ''}
            onChange={handleChange}
          />
        </Col>

        <Col md={2} sm={6}>
          <Form.Label className="small text-muted mb-1">Ordenar por</Form.Label>
          <Form.Select name="ordem" value={filters.ordem || 'recentes'} onChange={handleChange} size="sm">
            <option value="recentes">Mais Recentes</option>
            <option value="antigos">Mais Antigos</option>
            <option value="mais_views">Mais {DICT.METRIC_PLUR}</option>
            <option value="menos_views">Menos {DICT.METRIC_PLUR}</option>
          </Form.Select>
        </Col>
      </Row>
    </div>
  );
};

export default FilterSection;
